import React, { useState, useRef, useEffect } from "react";
import { useNavigate, useLocation, Link } from "react-router-dom";
import Header from "../components/Header";
import Footer from "../components/Footer";
import Breadcrumb from "../components/Breadcrumb";
import { postData } from "../api/client";
import endpoints from "../api/endpoints";
import { setToken } from "../api/auth";
import { useSiteLogo } from "../api/siteLogo";

function Login() {
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);
  const [message, setMessage] = useState(null);

  const navigate = useNavigate();
  const location = useLocation();
  const timeoutRef = useRef();
  const logo = useSiteLogo();

  useEffect(() => {
    return () => timeoutRef.current && clearTimeout(timeoutRef.current);
  }, []);

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError(null);
    setMessage(null);

    if (!email || !password) {
      setError("Email and password are required");
      return;
    }

    setLoading(true);

    try {
      const data = await postData(endpoints.LOGIN, { email, password });

      setMessage(data?.message || "Login successful");

      if (data?.token) {
        setToken(data.token);
      }

      setPassword("");

      const destination = location?.state?.from?.pathname || "/";

      timeoutRef.current = setTimeout(
        () => navigate(destination, { replace: true }),
        1000
      );
    } catch (err) {
      if (!err.status) {
        setError("Server not reachable. Please try again.");
      } else {
        setError(err.message || "Invalid email or password");
      }
    } finally {
      setLoading(false);
    }
  };

  return (
    <>
      <Header />
      <Breadcrumb title="Login" />

      <div className="auth-area py-120">
        <div className="container">
          <div className="col-md-5 mx-auto">
            <div className="auth-form">
              <div className="auth-header">
                <img src={logo} alt="Kademy Logo" />
                <p>Login with your Kademy account</p>
              </div>

              <form onSubmit={handleSubmit}>
                {message && (
                  <p className="text-success text-center mb-2">{message}</p>
                )}
                {error && (
                  <p className="text-danger text-center mb-2">{error}</p>
                )}

                <div className="form-group">
                  <div className="form-icon">
                    <i className="far fa-envelope"></i>
                    <input
                      type="email"
                      className="form-control"
                      placeholder="Your Email"
                      value={email}
                      onChange={(e) => setEmail(e.target.value)}
                      required
                    />
                  </div>
                </div>

                <div className="form-group">
                  <div className="form-icon">
                    <i className="far fa-key"></i>
                    <input
                      type="password"
                      className="form-control"
                      placeholder="Your Password"
                      value={password}
                      onChange={(e) => setPassword(e.target.value)}
                      required
                    />
                  </div>
                </div>

                <div className="auth-group">
                  <div className="form-check">
                    <input
                      className="form-check-input"
                      type="checkbox"
                      id="remember"
                    />
                    <label className="form-check-label" htmlFor="remember">
                      Remember Me
                    </label>
                  </div>

                  <Link to="/forgot-password" className="auth-group-link">
                    Forgot Password?
                  </Link>
                </div>

                <div className="auth-btn">
                  <button
                    type="submit"
                    className="theme-btn"
                    disabled={loading}
                  >
                    <span className="far fa-sign-in"></span>
                    {loading ? " Logging in..." : " Login"}
                  </button>
                </div>
              </form>

              <div className="auth-bottom">
                <div className="auth-social">
                  <p>Continue with Google </p>
                  <div className="auth-social-list">
                    
                    <a
                      href="https://google.com"
                      target="_blank"
                      rel="noreferrer"
                    >
                      <i className="fab fa-google"></i>
                    </a>
                   
                  </div>
                </div>

                <p className="auth-bottom-text">
                  Don't have an account? <Link to="/register">Register.</Link>
                </p>
              </div>
            </div>
          </div>
        </div>
      </div>

      <Footer />
    </>
  );
}

export default Login;
